export default __webpack_public_path__ + "static/media/document.5bc508a9.svg";